export interface DataLayer {
  event?: string;
  eventPR?: string;
  pagename?: string;
  genericpagename?: string;
  category?: string;
  AccountBrand?: string;
  Manufacturer?: string;
  AccountBrandOffer?: string;
  ManufacturerOffer?: string;
  productNameOffer?: string;
  productModelOffer?: string;
  planNumber?: string;
  PRplanNumber?: string;
  productName?: string;
  productModel?: string;
  applianceName?: string;
  customerType?: string;
  PRFreeOffers?: number;
  PRUpgradeOffers?: number;
  PRErrorMessage?: string;
  JobReferenceNumber?: string;
  customerID?: string;
  OfferType?: string;
  PlanType?: string;
  outstandingMonthlyPayments?: number;
  remainingPayment?: number;
  PRStarted?: number;
  upgradeTaken?: string;
  NumberOfItems?: number;
  rrp?: number | string;
  upgrade?: number;
  PRGroup?: string;
  PRContinuedCover?: number;
  PRBooking?: string;
  PRContinuedCoverDuration?: number;
  PRContinuedCoverVisible?: string;
  installationTaken?: string;
  disposalTaken?: string;
  PRContinuedCoverTaken?: string;
  compareProductName?: string;
  compareProductNameOffer?: string;
  compareUpgrade?: string | number;
  delivery?: string | number;
  deliveryDate?: string;
  paymentOffer?: string;
  totalCostReplacement?: number;
  installation?: string | number;
  disposal?: string | number;
  WorldPayReferenceNumber?: string;
  imageloaded?: string;
  Category?: string;
  Action?: string;
  Label?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
  PRevent?: string;
  oldPolicy?: string;
  upsell_flag?: boolean;
  upsell_reason?: string;
}
